import React from "react";
import "./footer.scss";
import { logoimg } from "../../assets/images";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { handleNavigate } from "../../utils/helper";
import ChatBoat from "../chatboat/ChatBoat";
import { MdLocationOn } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";
import { SlSocialLinkedin } from "react-icons/sl";

const Footer = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(location.pathname, "Pathname");
  // console.log("year", year);
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer_content">
          <div className="item">
            <img src={logoimg} alt="logo" />
            <p>
              Kind care, cutting-edge treatments, and personnel dedicated to
              your health and rehabilitation.
            </p>
            <p className="location_p">
              {" "}
              <CiLocationOn />{" "}
              <span>
              <b style={{color:"#fff"}}>INDIA :</b>      Connaught Place 4 - S, DCM Building Barakhamba Road, Landmark:
                Near Metro Station, Delhi, Delhi{" "}
              </span>
            </p>
            <p className="location_p">
              {" "}
              <CiLocationOn />{" "}
              <span>
               <b style={{color:"#fff"}}>INDIA :</b>   UGF-4, P6, Ocean Complex Sector - 18. Landmark: Opposite GIP
                Mall, Noida-201301
              </span>
            </p>
            <p className="location_p">
              {" "}
              <CiLocationOn />{" "}
              <span>
               <b style={{color:"#fff"}}>UK :</b>   Bank Tower-I , 60 Sheepcote Street, Birmingham (UK), B168WG
              </span>
            </p>
            <p className="location_p">
              {" "}
              <CiLocationOn />{" "}
              <span>
                <b style={{color:"#fff"}}>USA :</b>  The Rotunda, East Gitting Street, Baltimore MD- 21230-4345, USA
              </span>
            </p>
            <div className="social_links">
              <ul>
                <li>
                  <Link
                    className="facebook"
                    to="https://www.facebook.com/holypillscare/"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link
                    className="instagram"
                    to="https://www.instagram.com/holypillscare"
                    target="_blank"
                  >
                    <FaInstagram />
                  </Link>
                </li>
                <li>
                  <Link
                    className="youtube"
                    to="https://www.youtube.com/@Holypillscare"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
                <li>
                  <Link
                    className="linkedin"
                    to="https://www.linkedin.com/company/holypillscare/"
                    target="_blank"
                  >
                    <SlSocialLinkedin />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="item">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    if (location.pathname !== "/") {
                      // alert("kokok")
                      navigate("/");
                      handleNavigate("/", "#home", navigate);
                    } else {
                      handleNavigate("/", "#home", navigate);
                    }
                  }}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    if (location.pathname !== "/about-us") {
                      handleNavigate("/about-us", "#whyUs", navigate);
                    } else {
                      handleNavigate("/about-us", "#whyUs", navigate);
                    }
                  }}
                >
                  Why Us
                </Link>
              </li>
              <li>
                {/* <Link onClick={() => handleNavigate('/', '#ContactUs', navigate)} */}
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    if (location.pathname !== "/") {
                      handleNavigate("/", "#ContactUs", navigate);
                    } else {
                      handleNavigate("/", "#ContactUs", navigate);
                    }
                  }}
                >
                  Contact Us
                </Link>
              </li>
              <li>
                {/* <Link onClick={() => handleNavigate('/', '#faq', navigate)}>FAQs</Link> */}
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    if (location.pathname !== "/") {
                      handleNavigate("/", "#faq", navigate);
                    } else {
                      handleNavigate("/", "#faq", navigate);
                    }
                  }}
                >
                  Faq
                </Link>
              </li>
            </ul>
          </div>
          <div className="item">
            <h4>Specialities</h4>
            <ul>
              <li>
                <Link to="/pcos-symptoms-causes-treatment">PCOS</Link>
              </li>
              <li>
                <Link to="/endometriosis-symptoms-causes-treatment">
                  Endometriosis
                </Link>
              </li>
              <li>
                <Link to="/menopause-symptoms-causes-treatment">Menopause</Link>
              </li>
              <li>
                <Link to="/postpartum-symptoms-causes-treatment">
                  Postpartum
                </Link>
              </li>
            </ul>
          </div>
          <div className="item">
            <h4>Help & Support</h4>
            <ul>
              <li>Support number</li>
              <li>
                <Link to="tel:+919999887833">+91 9999887833</Link>
              </li>
              <li>
                <Link to="tel:+919990709586"> +91 9990709586</Link>
              </li>

              <li>
                <strong>Support Email Address</strong>
              </li>
              <li>
                <a href="mailto:support@holypills.in">support@holypills.in</a>
              </li>
              <li>
                <a href="mailto:UK@holypills.in">UK@holypills.in</a>
              </li>
              <li>
                <a href="mailto:USA@holypills.in">USA@holypills.in</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="disclaimer_sec">
          <h4>Disclaimer</h4>
          <p>
            Holypills Clinic is intended to provide general information about
            Homeopathic treatments. The content on this platform is not a
            substitute for consultation, diagnosis, or treatment from a
            qualified Homeopathic doctor. Treatment outcomes may vary depending
            on the individual’s health condition. While Homeopathy can support
            many cases, we do not claim to cure every condition, and no
            guarantees of results are provided.
          </p>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <p>© Copyright {year}</p>
          <ul>
            <li>
              <Link to="/terms">Terms of Service </Link>
            </li>
            <li>
              <Link to="/policy">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
      <ChatBoat />
    </footer>
  );
};

export default Footer;
